// removed by extract-text-webpack-plugin
module.exports = {"logoWrapper":"_22cw36kahwt86CC-BR9ppF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/CompanyImage/CompanyImage.scss
// module id = 1579
// module chunks = 0